<app-screen-content>
  <ng-container title>
    <span class="title">Great, we've got your details!</span>
  </ng-container>

  <ng-container body>
    <section class="box-confirmation status-ai">
      <img src="assets/icons/ic-pending@3x.svg" alt="" />
      <div class="flow">Accredited Investor</div>
      <div class="status">Application under review</div>
      <div class="message">
        We will inform you via email regarding your application soon.
      </div>
    </section>
  </ng-container>
</app-screen-content>
